export default "__VITE_ASSET__OIo3yWzp__"